import { BaseDto } from "src/dtos/common/baseDto";

/** PLC 태그 수집이력(plc_tag_hist) DTO. 필드명은 DB 컬럼명을 따른다(백엔드 PlcTagHistDto) */
export interface PlcTagHistDto extends BaseDto {
	histId: number; // 이력 일련번호 (행 식별값)
	tagId: string; // 태그 고유번호 (예: PLC01_T130)
	valueNum: number | null; // 수집값 숫자형 (BOOL은 0/1, 문자열 태그는 null)
	valueStr: string | null; // 수집값 문자열형
	readAt: string; // 수집 시각 (yyyy-MM-dd HH:mm:ss)
	quality: string; // 값 상태 (GOOD/BAD/TIMEOUT)
	inserted: boolean; // 그리드 공통 상태: 신규 행 여부 (서버 컬럼 아님, 조회 전용 화면은 항상 false)
	isModified: boolean; // 그리드 공통 상태: 수정 여부 (서버 컬럼 아님, 조회 전용 화면은 항상 false)
}

/** PlcTagHistDto 기본값 — 그리드 빈 행·placeholder 생성에 사용 */
export const defaultPlcTagHistDto: PlcTagHistDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	histId: 0,
	tagId: '',
	valueNum: null,
	valueStr: null,
	readAt: '',
	quality: '',
	inserted: false,
	isModified: false,
};
